/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { useEffect } from 'react';

function useEventCallback<T extends (...args: any[]) => any>(fn: T): T {
  const ref = React.useRef<T>(fn);

  // we copy a ref to the callback scoped to the current state/props on each render
  useEffect(() => {
    ref.current = fn;
  });

  return React.useCallback((...args: any[]) => ref.current.apply(void 0, args), []) as T;
}

export { useEventCallback };
